const config = {
    'projectName' : 'Master Admin',
    'apiBaseURL' : "https://masteradmin3011api.classe365.com",
    'allowUser':['admin','support']
}

export default config;